import ReferencesUserSubordinates from 'features/references/referencesUserSubordination';
import { useTitle } from '../helpers';

/**
 * @page Reference subordinates page
 */

const ReferencesSubordinationPage = () => {
  useTitle('Информация о подчинённом');

  return (
    <div>
      <h3>Страница информации о подчинённом</h3>
      <ReferencesUserSubordinates />
    </div>
  );
};

export default ReferencesSubordinationPage;
